import React from "react";

const CareerTimeline = ({ data }) => {
  const { careerHistory = [] } = data || {};

  if (!careerHistory.length) {
    return null;
  }

  return (
    <section
      className="career-section section-padding"
      id="career"
      aria-labelledby="career-title"
    >
      <div className="container">

        {/* SECTION HEADER */}
        <div className="career-heading">

          <div className="career-heading-left">

            <p className="section-label">
              <span />
              PUBLIC SERVICE JOURNEY
            </p>

            <h2 id="career-title">
              A record of{" "}
              <em>service.</em>
            </h2>

          </div>

          <p className="career-heading-description">
            A timeline of public service, leadership and
            professional experience.
          </p>

        </div>


        {/* TIMELINE */}
        <div className="career-timeline">

          {careerHistory.map((career, index) => (

            <article
              className={`career-item ${
                career.current ? "is-current" : ""
              }`}
              key={
                career.id ||
                `${career.position}-${career.start_year}-${index}`
              }
            >

              {/* YEAR */}
              <div className="career-year">

                <span>
                  {career.start_year || "—"}
                </span>

                <small>
                  {career.end_year || "Present"}
                </small>

              </div>


              {/* TIMELINE MARKER */}
              <div
                className="career-marker"
                aria-hidden="true"
              >
                <span />
              </div>


              {/* CONTENT */}
              <div className="career-content">

                {career.current && (
                  <span className="current-badge">
                    CURRENT POSITION
                  </span>
                )}

                <h3>
                  {career.position || "Public Service"}
                </h3>

                {career.organization && (
                  <strong className="career-organization">
                    {career.organization}
                  </strong>
                )}

                {career.description && (
                  <p>
                    {career.description}
                  </p>
                )}

              </div>

            </article>

          ))}

        </div>

      </div>
    </section>
  );
};

export default CareerTimeline;